var React = require('react');

function CircleFullInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"6.5"}));
}

CircleFullInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13"};

module.exports = CircleFullInline;

CircleFullInline.default = CircleFullInline;
